import React from 'react';
import './Clients.css';

// Import clients Data
import { clients } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Clients = () => {

  return (
    <section className='clients'>

      {/* Client Slider Container */}
      <div className='client-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Autoplay]}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }} // Auto-scroll every 5 seconds
          breakpoints={{
            0: { slidesPerView: 2 },      // 2 slides for small screens
            450: { slidesPerView: 3 },    // 3 slides for medium screens
            768: { slidesPerView: 4 },    // 4 slides for tablets
            1024: { slidesPerView: 5 },   // 5 slides for desktops
          }} 
        >
        {/* Map over the clients array to render each client logo */}
        {clients.map((client, index) => {
            return (
              /* Render the client image */
              <SwiperSlide className='client-item' key={index}><img src={client} alt='Client Logo' /></SwiperSlide>
            )
          })
        }
        </Swiper>
      </div>
    </section>
  );
}

export default Clients;